<template>
  <v-col class="pb-0">
    <v-divider />

    <v-list
      two-line
      subheader
      width="100%"
      color="beige"
      class="bg pa-0"
    >
      <NotificationMessages
        :see-more="seeMore"
      />

      <v-list-item
        style="min-height:0;"
        v-if="notifications && notifications.length"
      >
        <v-btn
          text
          dark
          @click="handleSeeMoreClick"
          style="margin:0 auto;"
        >
          <span class="">
            {{ seeMore ? 'See Less...' : 'See More...' }}
          </span>
        </v-btn>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import NotificationMessages from '@/components/dashboard/NotificationMessages.vue'
import INotification from '@/types/models/notification.model'

@Component({
  components: {
    NotificationMessages
  },
  computed: {
    ...mapGetters(['notifications'])
  }
})
export default class Notifications extends Vue {
  seeMore: boolean = false

  handleSeeMoreClick () {
    this.seeMore = !this.seeMore
  }
}
</script>
